/* eslint-disable function-paren-newline */
import { ActionPerformed } from '@capacitor/push-notifications';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { loadUserNotifications } from './thunkActions/push';
import { IPushState } from './types';

const getInitialState = (): IPushState => ({
    actions: [],
    notifications: [],
    currentRequestId: undefined,
});

export const pushSlice = createSlice({
    name: 'push',
    initialState: getInitialState(),
    reducers: {
        pushAdd: (state, action: PayloadAction<ActionPerformed>) => ({ ...state, actions: [action.payload, ...state.actions] }),
        pushRemove: (state, action: PayloadAction<ActionPerformed>) => ({
            ...state,
            actions: state.actions.filter(n => n.notification.id !== action.payload.notification.id),
        }),
        pushClearChannel: (state, action: PayloadAction<string>) => ({
            ...state,
            actions: state.actions.filter(n => n.notification.data.channel !== action.payload),
        }),
        webPushAdd: (state, action) => ({ ...state, notifications: [action.payload, ...state.notifications] }),
        webPushRemove: (state, action) => ({
            ...state,
            notifications: state.notifications.filter(n => n.custom.notId !== action.payload.custom.notId),
        }),
    },
    extraReducers: builder => builder
        .addCase(loadUserNotifications.pending, (state, action) => {
            if (!state.currentRequestId) {
                return { ...state, currentRequestId: action.meta.requestId };
            }
            return state;
        })

        .addCase(loadUserNotifications.rejected, (state, action) => {
            const { requestId } = action.meta;
            if (state.currentRequestId === requestId) {
                return { ...state, currentRequestId: undefined };
            }
            return state;
        })

        .addCase(loadUserNotifications.fulfilled, (state, action) => {
            const { requestId } = action.meta;
            if (state.currentRequestId === requestId) {
                return { ...state, notifications: action.payload, currentRequestId: undefined };
            }
            return state;
        }),
});

export const { pushAdd, pushClearChannel, pushRemove, webPushAdd, webPushRemove } = pushSlice.actions;

export const push = pushSlice.reducer;
